import React, { useRef, useState } from "react";

const ImageMagnifier = ({ src, zoom = 2 }) => {
  const [isHovered, setIsHovered] = useState(false);
  const containerRef = useRef(null);
  const imgRef = useRef(null);
  const lastPosition = useRef({ x: 0, y: 0 });

  const handleMouseMove = (e) => {
    if (!containerRef.current) return;

    const rect = containerRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const xPercent = (x / rect.width) * 100;
    const yPercent = (y / rect.height) * 100;

    lastPosition.current = { x: xPercent, y: yPercent };

    if (imgRef.current) {
      imgRef.current.style.transform = `translate(${-xPercent * (zoom - 1)}%, ${
        -yPercent * (zoom - 1)
      }%) scale(${zoom})`;
    }
  };

  return (
    <div
      ref={containerRef}
      className="relative overflow-hidden"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onMouseMove={handleMouseMove}
    >
      {/* Base Image */}
      <img src={src} alt="Zoomable" className="w-full h-full object-cover" />

      {/* Zoomed Layer (always present but hidden) */}
      <div
        className={`absolute inset-0 pointer-events-none transition-opacity duration-200 ${
          isHovered ? "opacity-100" : "opacity-0"
        }`}
      >
        <img
          ref={imgRef}
          src={src}
          alt="Zoomed preview"
          className="w-full h-full will-change-transform origin-top-left"
          style={{
            transform: `translate(${-lastPosition.current.x * (zoom - 1)}%, ${
              -lastPosition.current.y * (zoom - 1)
            }%) scale(${zoom})`,
          }}
        />
      </div>
    </div>
  );
};

export default ImageMagnifier;
